/* eslint-disable no-underscore-dangle */
import { setupQualtrics } from './setup';

const updateQuatricsEvents = (eventName) => {
  window.qualtrics = {
    ...window.qualtrics,
    isLoaded: true,
    events: {
      // we replace all previous events, because we only want 1 event
      // based prompt to show at any given time
      [eventName]: true,
    },
  };
};

export const triggerQualtricsEvent = (eventName) => {
  // don't trigger event if qualtrics isn't setup
  if (!window.qualtrics) { return false; }

  // Always push the event to qualtrics, so they can track how many times
  // it fires.
  window._qsie = window._qsie || [];
  window._qsie.push(eventName);

  // Only update qualtrics if the event wasn't previously set
  if (!window.qualtrics.events[eventName]) {
    updateQuatricsEvents(eventName);

    if (window.QSI && window.QSI.API) {
      // re-run qualtrics to show dynamic popups
      const { API } = window.QSI;
      API.unload();
      API.load();
      API.run();

      return true;
    }
  }
  return false;
};

export const updateGlobalQualtricsData = (serverContext) => {
  let {
    CurrentUser,
    CurrentCustomer,
    CurrentAccount,
    Identity,
    Omniture,
  } = serverContext;

  CurrentUser = CurrentUser || {};
  CurrentCustomer = CurrentCustomer || {};
  CurrentAccount = CurrentAccount || {};
  Identity = Identity || {};
  Omniture = Omniture || {};

  window.qualtrics = {
    aid: CurrentAccount.Id,
    cid: CurrentAccount.AdvertiserCustomerID,
    uid: CurrentUser.Id,
    CustomerName: CurrentCustomer.Name,
    AccountMode: CurrentAccount.AccountMode,
    UserName: CurrentUser.Name || Identity.UserName,
    Email: CurrentUser.Email || Identity.Email,
    SessionId: Omniture.SessionId,
    events: {},
    isLoaded: false,
    Language: CurrentUser.Language,
    IsInternal: CurrentUser.IsInternal,
  };
};

export function setupQualtricsWithData(serverContext) {
  updateGlobalQualtricsData(serverContext);
  setupQualtrics();
}
